// src/components/MonthNavigator.js
import React from "react";

const MonthNavigator = ({ month, year, onPrev, onNext }) => {
  return (
    <div className="calendar-header">
      <div id="prev-month-button" onClick={onPrev}>
        ←
      </div>
      <h5 id="month-year">{`${month} ${year}`}</h5>
      <div id="next-month-button" onClick={onNext}>
        →
      </div>
    </div>
  );
};

export default MonthNavigator;